export function randomNumber(max = 100) {
    return Math.ceil((Math.random() * max) + 1)
}

export const RandomNumber = {
    methods: {
        randomNumber
    }
}
